"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var MovingPage = function MovingPage(_ref) {
  var heading = _ref.heading,
      subText = _ref.subText;
  return _react.default.createElement(_UISection.default, {
    use: "island"
  }, _react.default.createElement(_UIFlex.default, {
    direction: "column",
    align: "center",
    justify: "between"
  }, _react.default.createElement(_UIIllustration.default, {
    name: "moving-truck",
    height: 200
  }), _react.default.createElement("h2", null, heading), subText && _react.default.createElement("p", null, subText)));
};

MovingPage.propTypes = {
  heading: _react.PropTypes.node.isRequired,
  subText: _react.PropTypes.node
};
var _default = MovingPage;
exports.default = _default;
module.exports = exports.default;